import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/tetris',
    name: 'tetris',
    component: () => import('../views/TetrisView.vue')
  },
  {
    path: '/alphabet-dash',
    name: 'alphabet-dash',
    component: () => import('../views/AlphabetDashView.vue')
  },
  {
    path: '/bird-flight',
    name: 'bird-flight',
    component: () => import('../views/BirdFlightView.vue')
  },
  {
    path: '/snake-game',
    name: 'snake-game',
    component: () => import('../views/SnakeGameView.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../views/PrivacyPolicyView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/game-guide',
    name: 'GameGuide',
    component: () => import('../views/GameGuideView.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('../views/DisclaimerView.vue')
  },
  {
    path: '/reaction-time',
    name: 'reaction-time',
    component: () => import('../views/ReactionTimeView.vue')
  },
  {
    path: '/memory-numbers',
    name: 'memory-numbers',
    component: () => import('../views/MemoryNumbersView.vue')
  },
  {
    path: '/typing-race',
    name: 'typing-race',
    component: () => import('../views/TypingRaceView.vue')
  },
  {
    path: '/sudoku',
    name: 'sudoku',
    component: () => import('../views/SudokuView.vue')
  },
  {
    path: '/color-match',
    name: 'color-match',
    component: () => import('../views/ColorMatchView.vue')
  },
  {
    path: '/2048',
    name: '2048',
    component: () => import('../views/Game2048View.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router